import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TagModule } from 'primeng/tag';
import { BehaviorSubject, Observable } from 'rxjs';
import { getTrackModeI18nKey } from '../../../../utils/booking-track-mode.util';

@Component({
  selector: 'client-appointment-booking-v2-indicators-cell',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TagModule, TranslateModule, AsyncPipe],
  template: `
    @if ({ row: columnData | async }; as $) {
      @if ($.row) {
        <div class="flex flex-wrap gap-1">
          @if ($.row.is_first_time_appointment) {
            <p-tag
              severity="info"
              styleClass="text-xxs"
              [value]="'CLIENT_BOOKING.V2.FIRST_TIME' | translate"
            />
          }
          @if ($.row.is_comp_session) {
            <p-tag
              severity="secondary"
              styleClass="text-xxs"
              [value]="'CLIENT_BOOKING.V2.COMP_SESSION' | translate"
            />
          }
          @if ($.row.is_late_cancel) {
            <p-tag
              severity="warn"
              styleClass="text-xxs"
              [value]="'CLIENT_BOOKING.V2.LATE_CANCEL' | translate"
            />
          }
          @if (trackModeKey($.row)) {
            <p-tag
              severity="secondary"
              styleClass="text-xxs"
              [value]="trackModeKey($.row) | translate"
            />
          }
        </div>
      }
    }
  `,
})
export class ClientAppointmentBookingV2IndicatorsCellComponent {
  columnData: Observable<unknown> = new BehaviorSubject(null);

  trackModeKey(row: { created_track_mode?: unknown }): string {
    return getTrackModeI18nKey(
      row.created_track_mode as Parameters<typeof getTrackModeI18nKey>[0],
    );
  }
}
